import { Button } from '@mui/material';
import BaseTable from 'components/ui/tables/BaseTable';
import useTopPanel from 'hooks/useTopPanel';
import { memo, useEffect, useState } from 'react';
import AddEditModal from './AddEditModal';
import SimpleSearchInput from 'components/SearchInputNavbar';
import FinanceFilterDrawer from '../../../components/dashboard/FinanceFilterDrawer';

const Money = () => {
  const { setComponent } = useTopPanel();

  useEffect(() => {
    setComponent(<div className='component-title'>Moliya</div>);
  }, []);

  const [refetch, setRefetch] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [itemData, setItemData] = useState('');

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
              onClick={() => setOpenFilter(true)}
            >
              Filter
            </Button>
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 flex items-center justify-center'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              color='success'
              className='!mx-2'
              onClick={() => setOpenModal(true)}
            >
              <i className='bi bi-plus-circle' />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath='admin/supplier-money/index'
          emitTableColumns={{ open, setOpen }}
          tableName='admin/supplier-money/index'
          headCells={[
            { code: 'account', label: 'Kassa' },
            { code: 'supplier', label: 'Yuk Beruvchi' },
            { code: 'sum', label: 'UZS' },
            { code: 'valute', label: 'USD' },
            { code: 'created_at', label: 'Sana' },
            { code: 'comment', label: 'Izoh' },
            { code: 'user', label: "Mas'ul shaxs" },
          ]}
          columns={[
            { code: 'account', type: 'nested', childStr: 'name' },
            { code: 'supplier', type: 'nested', childStr: 'name' },
            { code: 'sum', type: 'priceSum' },
            { code: 'valute', type: 'price' },
            { code: 'created_at', type: 'date' },
            { code: 'comment' },
            { code: 'staff', type: 'nested', childStr: 'name' },
          ]}
          actionsList={[
            {
              icon: 'bi bi-pencil-square',
              btnColor: 'info',
              setOpen: setOpenModal,
              setData: setItemData,
            },
          ]}
        />
      </div>
      {openModal && (
        <AddEditModal
          open={openModal}
          setOpen={setOpenModal}
          itemData={itemData}
          setItemData={setItemData}
          setRefetch={setRefetch}
        />
      )}
      <FinanceFilterDrawer open={openFilter} setOpen={setOpenFilter} />
    </div>
  );
};

export default memo(Money);
